import store from '@/store';
import http from '../utils/http';

export default {
    async getAllRecommendationProducts() {
        try {
            const { results } = await http.post('/rec-pack/list', {
                search_type: 'T',
                pack_cd: '',
            }, {}, {
                noSpinner: true,
            });

            return results;
        } catch (e) {
            store.dispatch('newError', {
                msg: '추천팩 정보를 가져올 수 없습니다. 잠시 후 다시 시도해 주세요.',
                error: e,
            });

            return [];
        }
    },

    async getAllProducts() {
        try {
            const { results } = await http.post('/product/list', {
                search_type: 'L',
                category_cd: '',
                category: '',
                item_sku: '',
                item_name: '',
                ingredients_name: '',
                useyn: '',
            }, {}, {
                noSpinner: true,
            });
            return results;
        } catch (e) {
            store.dispatch('newError', {
                msg: '상품 정보를 가져올 수 없습니다. 잠시 후 다시 시도해 주세요.',
                error: e,
            });
            return [];
        }
    },

    async getAllProductsIncludeUseN() {
        try {
            const { results } = await http.post('/product/list', {
                search_type: 'A',
                category_cd: '',
                category: '',
                item_sku: '',
                item_name: '',
                ingredients_name: '',
                useyn: '',
            }, {}, {
                noSpinner: true,
            });
            return results;
        } catch (e) {
            store.dispatch('newError', {
                msg: '상품 정보를 가져올 수 없습니다. 잠시 후 다시 시도해 주세요.',
                error: e,
            });
            return [];
        }
    },

    // async getAllProductsGroupedByCategory() {
    //   const results = await this.getAllProducts();

    //   const productsGroup = {};
    //   results.forEach((n) => {
    //     const { category } = n;
    //     if (!productsGroup[category]) {
    //       productsGroup[category] = [];
    //     }
    //     productsGroup[category].push(n);
    //   });

    //   return productsGroup;
    // },

    splitProductsByCategoryGroup(products) {
        const productsGroup = {};
        products.forEach((n) => {
            const { category } = n;
            if (!productsGroup[category]) {
                productsGroup[category] = [];
            }
            productsGroup[category].push(n);
        });

        return productsGroup;
    },

    async getIngridientCalculationResult(products) {
        try {
            const { results } = await http.post('/product/calculation', {
                dose_info: products,
            });

            return results;
        } catch (e) {
            store.dispatch('newError', {
                msg: '함량 정보를 가져올 수 없습니다. 잠시 후 다시 시도해 주세요.',
                error: e,
            });
            throw new Error(e);
        }
    },

    /**
   *
   * @param params
   *
{
	"dose_info": [
    {
      "item_sku": "303671K",
      "dose_cnt": "3"
    },
		{
			"item_sku": "303689K",
			"dose_cnt": "10"
		}

	],
	"take_days": 60
}
   */
    async getCalculatedPrices(params) {
        try {
            const { results } = await http.post('/product/price', params);
            // throw new Error('aaa');
            return results;
        } catch (e) {
            store.dispatch('newError', {
                msg: '최종 가격 정보를 가져올 수 없습니다. 잠시 후 다시 시도해 주세요.',
                error: e,
            });
            return {
                bv: '-',
                price: '-',
                pv: '-',
            };
        }
    },
};